import { render } from "./RemoteWorkRequests.vue?vue&type=template&id=6a418b8a&scoped=true"
import script from "./RemoteWorkRequests.vue?vue&type=script&lang=js"
export * from "./RemoteWorkRequests.vue?vue&type=script&lang=js"

import "./RemoteWorkRequests.vue?vue&type=style&index=0&id=6a418b8a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a418b8a"]])

export default __exports__